import { render, staticRenderFns } from "./CatalogSkeleton.vue?vue&type=template&id=8dd0fd08&scoped=true&"
import script from "./CatalogSkeleton.vue?vue&type=script&lang=js&"
export * from "./CatalogSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSkeleton.vue?vue&type=style&index=0&id=8dd0fd08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd0fd08",
  null
  
)

export default component.exports